var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 50,
    viewBox: "8 0 35 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #FFFAF1;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25,8.35c-5.92,0-11.42,3.05-14.58,8.06v-2.75c0-.73-.59-1.33-1.33-1.33s-1.33.59-1.33,1.33v6.63c0,.73.59,1.33,1.33,1.33h6.63c.73,0,1.33-.59,1.33-1.33s-.59-1.33-1.33-1.33h-3.7c3.67-7.16,12.44-10,19.61-6.33,7.16,3.67,10,12.44,6.33,19.61-3.67,7.16-12.44,10-19.61,6.33-3.71-1.9-6.43-5.3-7.47-9.33-.18-.71-.91-1.14-1.62-.95s-1.14.91-.95,1.62h0c2.38,9.21,11.78,14.75,20.99,12.37,9.21-2.38,14.75-11.78,12.37-20.99-1.96-7.6-8.82-12.92-16.68-12.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.11,17.44c1.47,3.39,1.83,7.06,1.89,10.7,0,0-1.52-1.94-1.52-1.94,3.5.95,6.95,2.18,9.87,4.41,0,0-.05.22-.05.22-3.52-.78-7.01-1.68-10.52-2.51.04-3.62.02-7.25.11-10.87h.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory);
export default __webpack_public_path__ + "static/media/icon-history.681742d2e6805c71dd684eebd39cd6e5.svg";
export { ForwardRef as ReactComponent };